var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1628 9.83945L12.1374 0.818743L11.5324 0.213781C11.3946 0.0768506 11.2082 0 11.0139 0C10.8196 0 10.6332 0.0768506 10.4953 0.213781L0.865001 9.83945C0.72376 9.98014 0.612135 10.1477 0.536715 10.3322C0.461295 10.5168 0.423608 10.7146 0.425878 10.9139C0.435221 11.7361 1.1196 12.3924 1.94179 12.3924H2.93448V20H19.0933V12.3924H20.107C20.5064 12.3924 20.8825 12.2359 21.1651 11.9533C21.3043 11.8146 21.4145 11.6496 21.4895 11.468C21.5645 11.2864 21.6027 11.0917 21.6019 10.8952C21.6019 10.4981 21.4454 10.1221 21.1628 9.83945V9.83945ZM12.3219 18.3183H9.70585V13.5533H12.3219V18.3183ZM17.4115 10.7107V18.3183H13.8168V12.9927C13.8168 12.4765 13.3987 12.0584 12.8825 12.0584H9.14527C8.62907 12.0584 8.21097 12.4765 8.21097 12.9927V18.3183H4.61623V10.7107H2.3739L11.0162 2.07538L11.5558 2.61494L19.6562 10.7107H17.4115Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.29d48a618bd4d41d1f4355b8d4d9102f.svg";
export { ForwardRef as ReactComponent };